import { CSSProperties } from 'react';

import { colors } from '@/utils';

const iconWidth = '1rem';
const iconHeight = '1rem';
const menuIconWidth = '1.5rem';
const menuIconHeight = '1.5rem';
/** Keycap icons take the keycap's text color. */
export const iconStyle: CSSProperties = {
  color: 'inherit',
  minWidth: iconWidth,
  minHeight: iconHeight,
};

export const menuIonStyle: CSSProperties = {
  color: colors.text.info.on.soft['300'],
  minWidth: menuIconWidth,
  minHeight: menuIconHeight,
};
